import BookTimeManagement from "./book-time-management.page";

export default BookTimeManagement;
